import { render, staticRenderFns } from "./TaxesPage.vue?vue&type=template&id=2b72e9df"
import script from "./TaxesPage.vue?vue&type=script&lang=js"
export * from "./TaxesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports